export interface DatedBlogPost {
  datum: string;
}

function germanDateToTimestamp(datum: string): number {
  const normalized = datum.trim().replace(/\u00a0/g, " ");
  const match = normalized.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
  const isoMatch = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:T.*)?$/);
  const day = match ? Number(match[1]) : isoMatch ? Number(isoMatch[3]) : NaN;
  const month = match ? Number(match[2]) : isoMatch ? Number(isoMatch[2]) : NaN;
  const year = match ? Number(match[3]) : isoMatch ? Number(isoMatch[1]) : NaN;
  if (![day, month, year].every(Number.isFinite)) return Number.NEGATIVE_INFINITY;

  const timestamp = Date.UTC(year, month - 1, day);
  const parsed = new Date(timestamp);

  return parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
    ? timestamp
    : Number.NEGATIVE_INFINITY;
}

/**
 * Sortiert Beiträge robust nach Veröffentlichungsdatum absteigend.
 * Bei gleichem Datum wird die spätere Tabellenzeile zuerst ausgegeben,
 * weil sie den zuletzt erzeugten Beitrag repräsentiert.
 */
export function sortBlogPostsNewestFirst<T extends DatedBlogPost>(posts: T[]): T[] {
  return posts
    .map((post, index) => ({ post, index, timestamp: germanDateToTimestamp(post.datum) }))
    .sort((left, right) => right.timestamp - left.timestamp || right.index - left.index)
    .map(({ post }) => post);
}

/** Entfernt doppelte veröffentlichte Datensätze, ohne die Sheet-Zeilen zu verändern. */
export function dedupeBlogPostsBySlug<T extends DatedBlogPost & { slug?: string }>(posts: T[]): T[] {
  const seen = new Set<string>();
  return posts.filter((post) => {
    const key = post.slug?.trim();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
